var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconTwitterPrimaryLinear3232 = function SvgIconTwitterPrimaryLinear3232(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon-twitter-primary-linear-32*32_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-twitter-primary-linear-32*32_svg__b)",
    d: "M16 0C7.164 0 0 7.164 0 16s7.164 16 16 16 16-7.164 16-16S24.836 0 16 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m17.75 14.556 6.85-7.962h-1.623l-5.947 6.913-4.75-6.913H6.8l7.184 10.454L6.8 25.397h1.623l6.28-7.3 5.017 7.3H25.2l-7.45-10.841ZM9.01 7.816h2.493L22.978 24.23h-2.493L9.009 7.816Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-twitter-primary-linear-32*32_svg__b",
    x1: 12.684,
    x2: 19.638,
    y1: 11.117,
    y2: 38.368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9876"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE9B2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-twitter-primary-linear-32*32_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  })))));
};
export default SvgIconTwitterPrimaryLinear3232;